import {useGetAndSet} from "./useGetAndSet";
import {createSetJobWorkshopConfigData} from "../actions/dataActions";

export default function useJobWorkshopConfigData(params, dataFresh){
    return useGetAndSet("workshopconfig", params, createSetJobWorkshopConfigData, dataFresh);
}